import { Component } from '@angular/core';

@Component({
	selector: 'app-root',
	template: `
		<app-google-analytics-gtag></app-google-analytics-gtag>
		<ngx-spinner bdColor="rgba(51,51,51,0.8)" type="">
  			<img src='assets/images/spinner.svg' />
		</ngx-spinner>
		<router-outlet></router-outlet>
	`,
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'ToTT';
}
